import Roating from "./components/Roating";

function App() {
    return (
        <Roating/>
    );
}

export default App;
